import { useCallback } from "react"

import { TrackingCategory, TrackingEventPage, TrackingEvents } from "@app/types/GtmData"
import { trackBaseEvent, useAutomaticTrackingData } from "@ng-mw/shared-react-components"

interface DinnerSuggestionsEventPayload {
    action: string
    eventPage?: TrackingEventPage
    category?: TrackingCategory
    recipe?: {
        id: string
        name: string
    }
}

const useTrackDinnerSuggestionsEvent = () => {
    const automaticTrackingData = useAutomaticTrackingData()

    return useCallback(
        ({
            action,
            eventPage = TrackingEventPage.RecipesPage,
            category = eventPage === TrackingEventPage.DinnerSuggestionOnboarding
                ? TrackingCategory.DinnerSuggestionOnboarding
                : TrackingCategory.DinnerSuggestions,
            recipe,
        }: DinnerSuggestionsEventPayload) => {
            trackBaseEvent({
                ...automaticTrackingData,
                event: TrackingEvents.Recipes,
                action,
                category,
                event_page: eventPage,
                ...(recipe && {
                    recipe_id: recipe.id,
                    recipe_name: recipe.name,
                }),
            })
        },
        [automaticTrackingData],
    )
}

export default useTrackDinnerSuggestionsEvent
